import React, {useState} from 'react'
import './Main.css'
import Input from '../components/Input'
import Error from '../components/Error'
import Output from '../components/Output'
import Progress from '../components/Progress'

const Home = () => {

    const [file, setFile] = useState(null)
    const [error, setError] = useState('')

    const types = ['image/jpeg','image/jpg','image/png']

    return (
        <div>           
            <Input setFile={setFile} setError={setError} types={types} />
            {error && <Error error={error}/>}
            {file && <Progress file={file} setFile={setFile}/>}
            <Output/>
        </div>
    )
}

export default Home